import { render, staticRenderFns } from "./adminpercentage.vue?vue&type=template&id=26e7152a&scoped=true"
import script from "./adminpercentage.vue?vue&type=script&lang=js"
export * from "./adminpercentage.vue?vue&type=script&lang=js"
import style0 from "./adminpercentage.vue?vue&type=style&index=0&id=26e7152a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e7152a",
  null
  
)

export default component.exports